import { DocumentTypeHandler } from "@/dbot/common/commonDomain";
import {
  applyForm,
  applyOverrides,
  CustomDocumentData,
  CustomDocumentForm,
  CustomDocumentOverrides,
  getCustomDocumentTitle,
} from "./customDocumentDomain";
import { DocumentType } from "@/common/documents";

export const customDocumentHandler: DocumentTypeHandler<
  DocumentType.custom_document,
  CustomDocumentData,
  CustomDocumentForm,
  CustomDocumentOverrides
> = {
  type: DocumentType.custom_document,
  initNewForm: (dispatch, context, options) => new CustomDocumentForm(dispatch, context, options),
  initForm: (form) => form.init(),
  applyForm: (form) => applyForm(form),
  applyOverrides: (form, orgNo) => applyOverrides(form, orgNo),
  getTitle: (form, lang) => getCustomDocumentTitle(form, lang),
  handleEvent: (form, event) => form.handleEvent(event),
  getRecipients: (form, orgNo) => (form.personalised ? form.getRecipientsForPreview(orgNo) : []),
  hasRecipientPreviews: (form) => form.personalised,
  validate: (form) => form.validate(),
};
